/**
 * API para Hefesto Models
 */

import api from '../../../shared/services/apiClient';

export interface HefestoModel {
  id: string;
  name: string;
  type: 'SINGLE_SOURCE' | 'MULTI_SOURCE';
  empresaId: string;
  sourceIds: string[];
  model: any; // El modelo completo (factTables, dimensions, etc)
  confidenceLevel: 'HIGH' | 'MEDIUM' | 'LOW';
  createdAt: string;
  updatedAt: string;
}

export const hefestoModelsApi = {
  /**
   * GET /api/hefesto-models
   * Obtiene todos los modelos de la empresa
   */
  listModels: async (): Promise<{ models: HefestoModel[]; count: number }> => {
    const response = await api.get('/hefesto-models');
    return response.data;
  },

  /**
   * GET /api/hefesto-models/:id
   * Obtiene un modelo específico con sus datasources
   */
  getModel: async (id: string): Promise<{ model: HefestoModel; datasources: any[] }> => {
    const response = await api.get(`/hefesto-models/${id}`);
    return response.data;
  },

  /**
   * POST /api/hefesto-models
   * Crea un nuevo modelo Hefesto
   */
  createModel: async (name: string, datasourceIds: string[]): Promise<{ model: HefestoModel }> => {
    const response = await api.post('/hefesto-models', {
      name,
      datasourceIds
    });
    return response.data;
  },

  /**
   * DELETE /api/hefesto-models/:id
   * Elimina un modelo Hefesto
   */
  deleteModel: async (id: string): Promise<void> => {
    await api.delete(`/hefesto-models/${id}`);
  }
};
